import { FormGroup, ControlValueAccessor } from '@angular/forms';
var CheckboxInputComponent = /** @class */ (function () {
    function CheckboxInputComponent() {
        this.label = 'Checkbox label';
        this.hideLabel = false;
        this.align_right = false;
        this.checked = null;
        this.disabledForm = false;
        this.parentForm = null;
        this.formControlName = null;
        this.formArrayName = null;
        this.id = null;
        // The internal data model
        this.innerValue = false;
        this.onChangeCallback = function (_) { };
    }
    Object.defineProperty(CheckboxInputComponent.prototype, "value", {
        // get accessor
        get: function () {
            return this.innerValue;
        },
        // set accessor including call the onchange callback
        set: function (v) {
            if (v !== this.innerValue) {
                this.innerValue = v;
                this.onChangeCallback(v);
            }
        },
        enumerable: true,
        configurable: true
    });
    // Set touched on blur
    CheckboxInputComponent.prototype.onBlur = function () {
        this.onTouchedCallback();
    };
    // From ControlValueAccessor interface
    CheckboxInputComponent.prototype.writeValue = function (value) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    };
    // From ControlValueAccessor interface
    CheckboxInputComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    // From ControlValueAccessor interface
    CheckboxInputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    return CheckboxInputComponent;
}());
export { CheckboxInputComponent };
